export {
  default as apartment,
  ReactComponent as Apartment,
} from '@assets/icons/use-cases/apartment.svg'    
